<script setup lang="ts">
import { EventListPageType } from '~/composables/types/strapiEventListPage'

definePageMeta({
  contentGroup: 'city',
  localeSpecificSlug: true,
})
</script>

<template>
  <event-list-page :page-type="EventListPageType.TEAMEVENT"></event-list-page>
</template>
